export const ToggleLeft = () => (
  <>
    <path
      d='M12.0012 15.8499L8.12118 11.9699L12.0012 8.08991C12.165 7.89861 12.2506 7.65253 12.2409 7.40086C12.2312 7.14918 12.1268 6.91044 11.9487 6.73235C11.7706 6.55425 11.5319 6.44992 11.2802 6.4402C11.0286 6.43048 10.7825 6.51608 10.5912 6.67991L6.00118 11.2699C5.81493 11.4573 5.71039 11.7107 5.71039 11.9749C5.71039 12.2391 5.81493 12.4925 6.00118 12.6799L10.5912 17.2699C10.7785 17.4562 11.032 17.5607 11.2962 17.5607C11.5604 17.5607 11.8138 17.4562 12.0012 17.2699C12.1864 17.08 12.29 16.8252 12.29 16.5599C12.29 16.2946 12.1864 16.0398 12.0012 15.8499Z'
      fill='currentColor'
    />
    <rect x='16.29' y='6.5' width='2' height='11' rx='1' fill='currentColor' />
  </>
)
